import React from 'react';

import { CsatOnsiteModalDisplayerHomepage } from '@zillow/csat-modal-displayer';
import { useViewerState } from '@zillow/shopper-platform-config';

import env from '../../env.factory';

export const CsatModalLoader: React.FC = () => {
    const { isLoggedIn } = useViewerState();

    if (!isLoggedIn) {
        return null;
    }

    return <CsatOnsiteModalDisplayerHomepage csatUrl={env.csatUrl} />;
};
